<template>
    <v-container v-if="okContainer()">
        <v-row>
            <v-col cols="12">
                <v-bottom-navigation fixed grow height="25">
                    <div>
                        <v-system-bar
                            :color="tertiaryColor(generalExApplicationEx)"
                            height="25"
                        >
                            <v-icon :color="environment.endpoint.color"
                                >mdi-calendar</v-icon
                            >
                            <span class="text-caption">{{
                                currentDate()
                            }}</span>
                            <v-spacer></v-spacer>
                            <v-icon />
                            <v-spacer></v-spacer>
                            <v-icon :color="environment.endpoint.color"
                                >mdi-account</v-icon
                            >
                            <span class="text-caption">{{
                                session.details.initials
                            }}</span>
                            <v-spacer></v-spacer>
                            <v-icon />
                            <v-spacer></v-spacer>
                            <v-icon :color="environment.endpoint.color"
                                >mdi-server</v-icon
                            >
                            <span class="text-caption">{{
                                environment.endpoint.title
                            }}</span>
                            <v-spacer></v-spacer>
                            <v-icon />
                            <v-spacer></v-spacer>
                            <v-icon :color="environment.endpoint.color"
                                >mdi-application</v-icon
                            >
                            <span class="text-caption">{{ version() }}</span>
                            <v-spacer></v-spacer>
                            <v-icon />
                            <v-spacer></v-spacer>
                            <v-icon :color="environment.endpoint.color"
                                >mdi-web</v-icon
                            >
                            <span class="text-caption">{{
                                frontVersion()
                            }}</span>
                            <v-spacer></v-spacer>
                            <v-progress-circular
                                v-if="secondsLeft && secondsLeft < 60"
                                :color="environment.endpoint.color"
                                size="20"
                                :value="progressLeft()"
                            ></v-progress-circular>
                        </v-system-bar>
                    </div>
                </v-bottom-navigation>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import moment from "moment";
import { version as frontVersion } from "./../../../../package.json";
export default {
    name: "SystemBar",
    props: ["session", "generalExApplicationEx", "environment", "secondsLeft"],
    data() {
        return {};
    },
    methods: {
        currentDate() {
            const date = moment().format("ll");
            return date;
        },
        version() {
            const thisVersion =
                this.generalExApplicationEx?.applicationEx?.application
                    ?.version ?? "?";
            return "v" + thisVersion;
        },
        frontVersion() {
            return "v" + frontVersion;
        },
        progressLeft() {
            const result =
                this.secondsLeft && this.secondsLeft > 60
                    ? 100
                    : (this.secondsLeft / 60) * 100;
            return result;
        },
        okContainer() {
            return (
                this.session?.loggedIn &&
                this.generalExApplicationEx?.applicationEx
            );
        },
    },
    updated() {},
    mounted() {},
};
</script>

<style>
</style>